// @format

export default {
	serialNumberParameter: 'sensor_serial_number',
};
